/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChunkCompleteRequest } from '../models';
// @ts-ignore
import type { ChunkInitRequest } from '../models';
// @ts-ignore
import type { ChunkInitResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { StorageAttachRequest } from '../models';
// @ts-ignore
import type { WaypointBatch } from '../models';
// @ts-ignore
import type { WaypointBatchResponse } from '../models';
// @ts-ignore
import type { WaypointDetailResponse } from '../models';
// @ts-ignore
import type { WaypointListItem } from '../models';
// @ts-ignore
import type { WaypointStatusResponse } from '../models';
// @ts-ignore
import type { WaypointUpdate } from '../models';
/**
 * ArtrackWaypointsApi - axios parameter creator
 */
export const ArtrackWaypointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Force HLS retry for an existing storage object id (admin tool).
         * @summary Admin Retry Hls
         * @param {number} storageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRetryHlsArtrackAdminRetryHlsStorageIdPost: async (storageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storageId' is not null or undefined
            assertParamExists('adminRetryHlsArtrackAdminRetryHlsStorageIdPost', 'storageId', storageId)
            const localVarPath = `/artrack/admin/retry_hls/{storage_id}`
                .replace(`{${"storage_id"}}`, encodeURIComponent(String(storageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach Storage To Waypoint
         * @param {number} waypointId 
         * @param {StorageAttachRequest} storageAttachRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost: async (waypointId: number, storageAttachRequest: StorageAttachRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost', 'waypointId', waypointId)
            // verify required parameter 'storageAttachRequest' is not null or undefined
            assertParamExists('attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost', 'storageAttachRequest', storageAttachRequest)
            const localVarPath = `/artrack/waypoints/{waypoint_id}/attach-storage`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storageAttachRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk delete waypoints for a track. - If `ids` is provided (comma-separated), deletes those IDs (only if they belong to track_id) - Else if `min_id` is provided, deletes all waypoints with id >= min_id belonging to track_id
         * @summary Bulk Delete Waypoints
         * @param {number} trackId 
         * @param {number | null} [minId] 
         * @param {string | null} [ids] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete: async (trackId: number, minId?: number | null, ids?: string | null, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/waypoints/bulk`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (minId !== undefined) {
                localVarQueryParameter['min_id'] = minId;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkCompleteRequest} chunkCompleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost: async (sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost', 'mediaSlot', mediaSlot)
            // verify required parameter 'chunkCompleteRequest' is not null or undefined
            assertParamExists('completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost', 'chunkCompleteRequest', chunkCompleteRequest)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}/complete-chunked`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chunkCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete upload session and finalize waypoint
         * @summary Complete Upload Session
         * @param {string} sessionId 
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUploadSessionArtrackUploadSessionIdCompletePost: async (sessionId: string, waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('completeUploadSessionArtrackUploadSessionIdCompletePost', 'sessionId', sessionId)
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('completeUploadSessionArtrackUploadSessionIdCompletePost', 'waypointId', waypointId)
            const localVarPath = `/artrack/upload/{session_id}/complete`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (waypointId !== undefined) { 
                localVarFormParams.set('waypoint_id', waypointId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create waypoints for a track
         * @summary Create Waypoints
         * @param {number} trackId 
         * @param {WaypointBatch} waypointBatch 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaypointsArtrackTrackIdWaypointsPost: async (trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('createWaypointsArtrackTrackIdWaypointsPost', 'trackId', trackId)
            // verify required parameter 'waypointBatch' is not null or undefined
            assertParamExists('createWaypointsArtrackTrackIdWaypointsPost', 'waypointBatch', waypointBatch)
            const localVarPath = `/artrack/{track_id}/waypoints`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waypointBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Waypoint
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaypointArtrackWaypointsWaypointIdDelete: async (waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('deleteWaypointArtrackWaypointsWaypointIdDelete', 'waypointId', waypointId)
            const localVarPath = `/artrack/waypoints/{waypoint_id}`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Waypoint Detail
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointDetailArtrackWaypointsWaypointIdGet: async (waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('getWaypointDetailArtrackWaypointsWaypointIdGet', 'waypointId', waypointId)
            const localVarPath = `/artrack/waypoints/{waypoint_id}`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get waypoint processing status
         * @summary Get Waypoint Status
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointStatusArtrackWaypointsWaypointIdStatusGet: async (waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('getWaypointStatusArtrackWaypointsWaypointIdStatusGet', 'waypointId', waypointId)
            const localVarPath = `/artrack/waypoints/{waypoint_id}/status`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Init Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkInitRequest} chunkInitRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost: async (sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost', 'mediaSlot', mediaSlot)
            // verify required parameter 'chunkInitRequest' is not null or undefined
            assertParamExists('initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost', 'chunkInitRequest', chunkInitRequest)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}/init`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chunkInitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List waypoints
         * @summary List Waypoints
         * @param {number} [trackId] 
         * @param {number} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsArtrackWaypointsGet: async (trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/waypoints/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (trackId !== undefined) {
                localVarQueryParameter['track_id'] = trackId;
            }

            if (segmentId !== undefined) {
                localVarQueryParameter['segment_id'] = segmentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return full waypoint details for a given track (coords, times, media summary).
         * @summary List Waypoints Detail
         * @param {number} trackId 
         * @param {number | null} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet: async (trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/waypoints/detail`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (segmentId !== undefined) {
                localVarQueryParameter['segment_id'] = segmentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Waypoint
         * @param {number} waypointId 
         * @param {WaypointUpdate} waypointUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaypointArtrackWaypointsWaypointIdPut: async (waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('updateWaypointArtrackWaypointsWaypointIdPut', 'waypointId', waypointId)
            // verify required parameter 'waypointUpdate' is not null or undefined
            assertParamExists('updateWaypointArtrackWaypointsWaypointIdPut', 'waypointUpdate', waypointUpdate)
            const localVarPath = `/artrack/waypoints/{waypoint_id}`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waypointUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Chunk Part
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {number} index 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut: async (sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'mediaSlot', mediaSlot)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'index', index)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'file', file)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}/parts/{index}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload media file for a waypoint
         * @summary Upload Media File
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {File} file 
         * @param {number} waypointId 
         * @param {string} mediaType 
         * @param {string | null} [xContentHash] 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [metadataJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMediaFileArtrackUploadSessionIdMediaSlotPost: async (sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'mediaSlot', mediaSlot)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'file', file)
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'waypointId', waypointId)
            // verify required parameter 'mediaType' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'mediaType', mediaType)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (waypointId !== undefined) { 
                localVarFormParams.append('waypoint_id', waypointId as any);
            }
    
            if (mediaType !== undefined) { 
                localVarFormParams.append('media_type', mediaType as any);
            }
    
            if (metadataJson !== undefined) { 
                localVarFormParams.append('metadata_json', metadataJson as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xContentHash != null) {
                localVarHeaderParameter['X-Content-Hash'] = String(xContentHash);
            }
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackWaypointsApi - functional programming interface
 */
export const ArtrackWaypointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackWaypointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Force HLS retry for an existing storage object id (admin tool).
         * @summary Admin Retry Hls
         * @param {number} storageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.adminRetryHlsArtrackAdminRetryHlsStorageIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attach Storage To Waypoint
         * @param {number} waypointId 
         * @param {StorageAttachRequest} storageAttachRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId: number, storageAttachRequest: StorageAttachRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId, storageAttachRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk delete waypoints for a track. - If `ids` is provided (comma-separated), deletes those IDs (only if they belong to track_id) - Else if `min_id` is provided, deletes all waypoints with id >= min_id belonging to track_id
         * @summary Bulk Delete Waypoints
         * @param {number} trackId 
         * @param {number | null} [minId] 
         * @param {string | null} [ids] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId: number, minId?: number | null, ids?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId, minId, ids, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkCompleteRequest} chunkCompleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId, mediaSlot, chunkCompleteRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete upload session and finalize waypoint
         * @summary Complete Upload Session
         * @param {string} sessionId 
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId, waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.completeUploadSessionArtrackUploadSessionIdCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create waypoints for a track
         * @summary Create Waypoints
         * @param {number} trackId 
         * @param {WaypointBatch} waypointBatch 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaypointBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWaypointsArtrackTrackIdWaypointsPost(trackId, waypointBatch, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.createWaypointsArtrackTrackIdWaypointsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Waypoint
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.deleteWaypointArtrackWaypointsWaypointIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Waypoint Detail
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaypointDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.getWaypointDetailArtrackWaypointsWaypointIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get waypoint processing status
         * @summary Get Waypoint Status
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaypointStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.getWaypointStatusArtrackWaypointsWaypointIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Init Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkInitRequest} chunkInitRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChunkInitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId, mediaSlot, chunkInitRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List waypoints
         * @summary List Waypoints
         * @param {number} [trackId] 
         * @param {number} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaypointListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWaypointsArtrackWaypointsGet(trackId, segmentId, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.listWaypointsArtrackWaypointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return full waypoint details for a given track (coords, times, media summary).
         * @summary List Waypoints Detail
         * @param {number} trackId 
         * @param {number | null} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaypointDetailResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, segmentId, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Waypoint
         * @param {number} waypointId 
         * @param {WaypointUpdate} waypointUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWaypointArtrackWaypointsWaypointIdPut(waypointId, waypointUpdate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.updateWaypointArtrackWaypointsWaypointIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Chunk Part
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {number} index 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId, mediaSlot, index, file, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload media file for a waypoint
         * @summary Upload Media File
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {File} file 
         * @param {number} waypointId 
         * @param {string} mediaType 
         * @param {string | null} [xContentHash] 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [metadataJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId, mediaSlot, file, waypointId, mediaType, xContentHash, xAPIKEY, metadataJson, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.uploadMediaFileArtrackUploadSessionIdMediaSlotPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackWaypointsApi - factory interface
 */
export const ArtrackWaypointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackWaypointsApiFp(configuration)
    return {
        /**
         * Force HLS retry for an existing storage object id (admin tool).
         * @summary Admin Retry Hls
         * @param {number} storageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach Storage To Waypoint
         * @param {number} waypointId 
         * @param {StorageAttachRequest} storageAttachRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId: number, storageAttachRequest: StorageAttachRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId, storageAttachRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk delete waypoints for a track. - If `ids` is provided (comma-separated), deletes those IDs (only if they belong to track_id) - Else if `min_id` is provided, deletes all waypoints with id >= min_id belonging to track_id
         * @summary Bulk Delete Waypoints
         * @param {number} trackId 
         * @param {number | null} [minId] 
         * @param {string | null} [ids] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId: number, minId?: number | null, ids?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId, minId, ids, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkCompleteRequest} chunkCompleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId, mediaSlot, chunkCompleteRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete upload session and finalize waypoint
         * @summary Complete Upload Session
         * @param {string} sessionId 
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId, waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Create waypoints for a track
         * @summary Create Waypoints
         * @param {number} trackId 
         * @param {WaypointBatch} waypointBatch 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointBatchResponse> {
            return localVarFp.createWaypointsArtrackTrackIdWaypointsPost(trackId, waypointBatch, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Waypoint
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Waypoint Detail
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointDetailResponse> {
            return localVarFp.getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get waypoint processing status
         * @summary Get Waypoint Status
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointStatusResponse> {
            return localVarFp.getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Init Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkInitRequest} chunkInitRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<ChunkInitResponse> {
            return localVarFp.initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId, mediaSlot, chunkInitRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * List waypoints
         * @summary List Waypoints
         * @param {number} [trackId] 
         * @param {number} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WaypointListItem>> {
            return localVarFp.listWaypointsArtrackWaypointsGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Return full waypoint details for a given track (coords, times, media summary).
         * @summary List Waypoints Detail
         * @param {number} trackId 
         * @param {number | null} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WaypointDetailResponse>> {
            return localVarFp.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Waypoint
         * @param {number} waypointId 
         * @param {WaypointUpdate} waypointUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateWaypointArtrackWaypointsWaypointIdPut(waypointId, waypointUpdate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Chunk Part
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {number} index 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId, mediaSlot, index, file, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload media file for a waypoint
         * @summary Upload Media File
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {File} file 
         * @param {number} waypointId 
         * @param {string} mediaType 
         * @param {string | null} [xContentHash] 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [metadataJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId, mediaSlot, file, waypointId, mediaType, xContentHash, xAPIKEY, metadataJson, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackWaypointsApi - interface
 */
export interface ArtrackWaypointsApiInterface {
    /**
     * Force HLS retry for an existing storage object id (admin tool).
     * @summary Admin Retry Hls
     * @param {number} storageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId: number, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Attach Storage To Waypoint
     * @param {number} waypointId 
     * @param {StorageAttachRequest} storageAttachRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId: number, storageAttachRequest: StorageAttachRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Bulk delete waypoints for a track. - If `ids` is provided (comma-separated), deletes those IDs (only if they belong to track_id) - Else if `min_id` is provided, deletes all waypoints with id >= min_id belonging to track_id
     * @summary Bulk Delete Waypoints
     * @param {number} trackId 
     * @param {number | null} [minId] 
     * @param {string | null} [ids] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId: number, minId?: number | null, ids?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Complete Chunked Upload
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {ChunkCompleteRequest} chunkCompleteRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Complete upload session and finalize waypoint
     * @summary Complete Upload Session
     * @param {string} sessionId 
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Create waypoints for a track
     * @summary Create Waypoints
     * @param {number} trackId 
     * @param {WaypointBatch} waypointBatch 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointBatchResponse>;

    /**
     * 
     * @summary Delete Waypoint
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Get Waypoint Detail
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointDetailResponse>;

    /**
     * Get waypoint processing status
     * @summary Get Waypoint Status
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointStatusResponse>;

    /**
     * 
     * @summary Init Chunked Upload
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {ChunkInitRequest} chunkInitRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<ChunkInitResponse>;

    /**
     * List waypoints
     * @summary List Waypoints
     * @param {number} [trackId] 
     * @param {number} [segmentId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WaypointListItem>>;

    /**
     * Return full waypoint details for a given track (coords, times, media summary).
     * @summary List Waypoints Detail
     * @param {number} trackId 
     * @param {number | null} [segmentId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WaypointDetailResponse>>;

    /**
     * 
     * @summary Update Waypoint
     * @param {number} waypointId 
     * @param {WaypointUpdate} waypointUpdate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Upload Chunk Part
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {number} index 
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * Upload media file for a waypoint
     * @summary Upload Media File
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {File} file 
     * @param {number} waypointId 
     * @param {string} mediaType 
     * @param {string | null} [xContentHash] 
     * @param {string} [xAPIKEY] 
     * @param {string | null} [metadataJson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any>;

}

/**
 * ArtrackWaypointsApi - object-oriented interface
 */
export class ArtrackWaypointsApi extends BaseAPI implements ArtrackWaypointsApiInterface {
    /**
     * Force HLS retry for an existing storage object id (admin tool).
     * @summary Admin Retry Hls
     * @param {number} storageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId: number, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).adminRetryHlsArtrackAdminRetryHlsStorageIdPost(storageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach Storage To Waypoint
     * @param {number} waypointId 
     * @param {StorageAttachRequest} storageAttachRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId: number, storageAttachRequest: StorageAttachRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).attachStorageToWaypointArtrackWaypointsWaypointIdAttachStoragePost(waypointId, storageAttachRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk delete waypoints for a track. - If `ids` is provided (comma-separated), deletes those IDs (only if they belong to track_id) - Else if `min_id` is provided, deletes all waypoints with id >= min_id belonging to track_id
     * @summary Bulk Delete Waypoints
     * @param {number} trackId 
     * @param {number | null} [minId] 
     * @param {string | null} [ids] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId: number, minId?: number | null, ids?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).bulkDeleteWaypointsArtrackTracksTrackIdWaypointsBulkDelete(trackId, minId, ids, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete Chunked Upload
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {ChunkCompleteRequest} chunkCompleteRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId, mediaSlot, chunkCompleteRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete upload session and finalize waypoint
     * @summary Complete Upload Session
     * @param {string} sessionId 
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId, waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create waypoints for a track
     * @summary Create Waypoints
     * @param {number} trackId 
     * @param {WaypointBatch} waypointBatch 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).createWaypointsArtrackTrackIdWaypointsPost(trackId, waypointBatch, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Waypoint
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Waypoint Detail
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get waypoint processing status
     * @summary Get Waypoint Status
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Init Chunked Upload
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {ChunkInitRequest} chunkInitRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId, mediaSlot, chunkInitRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List waypoints
     * @summary List Waypoints
     * @param {number} [trackId] 
     * @param {number} [segmentId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).listWaypointsArtrackWaypointsGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return full waypoint details for a given track (coords, times, media summary).
     * @summary List Waypoints Detail
     * @param {number} trackId 
     * @param {number | null} [segmentId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Waypoint
     * @param {number} waypointId 
     * @param {WaypointUpdate} waypointUpdate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).updateWaypointArtrackWaypointsWaypointIdPut(waypointId, waypointUpdate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Chunk Part
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {number} index 
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId, mediaSlot, index, file, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload media file for a waypoint
     * @summary Upload Media File
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {File} file 
     * @param {number} waypointId 
     * @param {string} mediaType 
     * @param {string | null} [xContentHash] 
     * @param {string} [xAPIKEY] 
     * @param {string | null} [metadataJson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId, mediaSlot, file, waypointId, mediaType, xContentHash, xAPIKEY, metadataJson, options).then((request) => request(this.axios, this.basePath));
    }
}

